import { t } from 'i18next';

export enum KeyLocation {
  SHARED_LIBRARY = 'SHARED_LIBRARY',
  JKS_KEYSTORE = 'JKS_KEYSTORE',
  JCEKS_KEYSTORE = 'JCEKS_KEYSTORE',
  PKCS12_KEYSTORE = 'PKCS12_KEYSTORE',
  CERTIFICATE = 'CERTIFICATE',
  PGP = 'PGP',
  PKCS1_KEY = 'PKCS1_KEY',
  PKCS8_KEY = 'PKCS8_KEY',
  SSH_KEY = 'SSH_KEY',
  PPK = 'PPK',
  X509_KEY = 'X509_KEY',
  OTHER_KEY = 'OTHER_KEY',
  JAR = 'JAR',
  PKCS7 = 'PKCS7',
  UNKNOWN = 'UNKNOWN',
}

export const getKeyLocationLabel = (location: KeyLocation): string => {
  return t(`keyProperties.locations.${location}`);
};
